import {
  REQUEST_HOME_PAGE,
  RECEIVE_HOME_PAGE,
  REQUEST_COMPETITORS_BRAND,
  RECEIVE_COMPETITORS_BRAND,
  UPDATE_GRAPH_TYPE,
  HOME_ACTIVE_TAB,
  REQUEST_HOME_PAGE_GRAPH,
  RECEIVE_HOME_PAGE_GRAPH,
} from "./home_actions";

const lodash = require("lodash");

const _nullState = {
  counts: {
    products: 0,
    videos: 0,
    influencers: 0,
  },
  trending: {
    videos: [],
    influencers: [],
  },
  recent: {
    videos: [],
    influencers: [],
  },
  demographics: {
    age: [],
    gender: [],
    ethnicity: [],
  },
  loadingHome: false,
  loaded_for: null,
  brand_engagement_graph: [],
  your_word_cloud: [],
  competitor_brands: [],
  isDataPresent: false,
};

const homeReducer = (state = _nullState, payload = {}) => {
  const { type, data } = payload;
  switch (type) {
    case REQUEST_HOME_PAGE:
      return { ...state, loadingHome: true, isDataPresent: false };
    case RECEIVE_HOME_PAGE:
      return { ...data, loadingHome: false, isDataPresent: true };
    default:
      return state;
  }
};

export default homeReducer;

const _nullCompetitorsState = {
  loading: false,
  competitors_brand: {},
};

export const home_competitor_brands = (
  state = _nullCompetitorsState,
  { type, competitors_brand }
) => {
  switch (type) {
    case REQUEST_COMPETITORS_BRAND:
      return { ...state, loading: true };
    case RECEIVE_COMPETITORS_BRAND:
      return {
        ...state,
        competitors_brand: { ...state.competitors_brand, ...competitors_brand },
        loading: false,
      };
    default:
      return state;
  }
};

const _nullData = {
  duration_wise_brand_engagement_graph: false,
  duration_wise_demographics_data: false,
  duration_wise_your_word_cloud: false,

  myBrandTab: {
    // duration_wise_brand_engagement_graph: {},
    // duration_wise_demographics_data: {},
    // duration_wise_your_word_cloud: {},
  },
  competitorTab: {},
};

export const home_Graph_Data = (state = _nullData, { type, data }) => {
  switch (type) {
    case REQUEST_HOME_PAGE_GRAPH:
      return { ...state, [data.url]: true };
    case RECEIVE_HOME_PAGE_GRAPH:
      if (!data.competitors_brands) {
        return {
          ...state,
          [data.url]: false,
          myBrandTab: {
            ...state.myBrandTab,
            [data.url]: {
              ...(state.myBrandTab[data.url] ? state.myBrandTab[data.url] : {}),
              [data.duration]: data.response,
            },
          },
        };
      } else if (data.competitors_brands) {
        let copyState = { ...state };
        copyState[data.url] = false;
        let { competitorTab } = copyState;
        if (competitorTab[data.competitors_brands]) {
          if (competitorTab[data.competitors_brands][data.url]) {
            if (
              competitorTab[data.competitors_brands][data.url][data.duration]
            ) {
              competitorTab[data.competitors_brands][data.url][data.duration] =
                data.response;
            } else {
              competitorTab[data.competitors_brands][data.url] = {
                ...competitorTab[data.competitors_brands][data.url],
                [data.duration]: data.response,
              };
            }
          } else {
            competitorTab[data.competitors_brands][data.url] = {
              [data.duration]: data.response,
            };
          }
        } else {
          competitorTab[data.competitors_brands] = {
            [data.url]: { [data.duration]: data.response },
          };
        }
        return { ...copyState };
      }
    default:
      return state;
  }
};

const _defaultState = {
  status: "6m",
};

export const switchGraphStatus = (state = _defaultState, { type, status }) => {
  switch (type) {
    case UPDATE_GRAPH_TYPE:
      return status;
    default:
      return state;
  }
};

const _defaultTabState = {
  activeTab: "My Brand",
};

export const switchActiveTab = (
  state = _defaultTabState,
  { type, activeTab }
) => {
  switch (type) {
    case HOME_ACTIVE_TAB:
      return activeTab;
    default:
      return state;
  }
};
